<template>
    <v-row>
        <v-col cols="12">
            <v-list two-line>
                <v-list-item v-for="(item, index) in tabsItems"
                             :key="item"
                             @click="$emit('changeTab', index)">
                    <v-list-item-content>
                        <v-list-item-title>{{item}}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-icon color="success" v-if="tabsState[index]">check</v-icon>
                        <v-icon color="error" v-else>clear</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-col>

        <v-col class="text-right" cols="12" >
            <v-btn color="abadPrimary" dark large style="text-transform: none">
                Crear Propiedad
                <v-icon right>send</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
  data () {
    return {
      tabsItems: [
        'Datos Inmueble',
        'Localización',
        'Características nnternas',
        'Áreas Comunes',
        'Fotos y Videos',
        'Portales',
        'Sitios de Interés'
      ]
    }
  },
  props: ['tabsState']
}
</script>
